(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.controller
  (:require
   [frontend.ui.component.lp-portal.report.company.overview.controller :refer [overview-figures]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name     (get-in report-data [:holding-name])
   :reference-date   (get-in report-data [:reference-date])
   :report-id        (:report-id props)
   :overview         {:case-overview-text       (report-ctl/rich-content
                                                 props
                                                 :case-overview-text)
                      :latest-development-text  (report-ctl/rich-content
                                                 props
                                                 :latest-development-text)
                      :value-creation-plan-text (report-ctl/rich-content
                                                 props
                                                 :value-creation-plan-text)
                      :overview-figures         (report-ctl/with-footnote
                                                 props
                                                 :overview-figures-footnotes
                                                 (overview-figures (get-in report-data
                                                                           [:basic-equity])))}
   :optional-section (report-ctl/optional-rich-content props
                                                       :optional-section-heading
                                                       :optional-section-text)})
